<template>
    <FormWrapper :is-loading="isLoading">
        <PageTitle title="Subordinates Attendance" slot="title" link="/helpContent/Subordinates Attendance" />
        <ValidationObserver ref="validator">
            <FormRow>  
                <div class="col-sm-2">
                    <inputDate label="Date" :items="staffList" item-name="NAME" item-value="id" v-model="filtering.attendanceDate"/>
                </div>
                <div class="col-sm-4">
                    <FormButton style="margin-top: 5px" type="primary" @click="search" :rounded="true">
                        <Icon type="ios-search" />
                    </FormButton>
                </div>
            </FormRow>
        </ValidationObserver>
        <DataTable :actions="true" 
        :data="subordinatesAttendance" 
        :columns="tableConfig"
        :is-loading="isLoading" 
        @on-selection-change="selectChange"
        @on-page-change="pageChange" 
        :pagination="pagination"
        @on-sort-change="sortChange">
        </DataTable>
    </FormWrapper>
    </template>
    <script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import DataTable from 'Components/DataTable'
    import loadingMixin from 'Mixins/loadingMixin'
    import InputDate from 'Components/form/InputDate';
    import {getSubordinatesAttendance,} from '../api'
    import tableConfig from './table'
    import {ValidationObserver} from 'vee-validate'
    export default {
        name: "List",
        mixins: [loadingMixin],
        components: {
            FormWrapper,
            DataTable,
            PageTitle,
            InputDate,
            ValidationObserver
        },
        data() {
            return {
                filtering: {
                    attendanceDate: '',
                },
                staffList: [],
                sorting: {
                    key: 'NAME',
                    order: 'asc'
                },
                pagination: {
                    perPage: 10,
                    page: 1,
                    total: 0
                },
                tableConfig,
                subordinatesAttendance: [],
                showMessage: {
                    isVisible: false,
                    message: ''
                },
                buttonToShow: '',
            }
        },
        computed: {
            userData() {
                return this.$store.state.user.user
            }
        },
        watch: {},
        created() {
            this.getDataByFilter()
        },
        methods: {
       
            search() {
                this.pagination.page = 1;
                this.getDataByFilter()
            },
            selectChange(data) {
                this.selectedRows = data;
            },
            sortChange(data) {
                this.sorting.key = data.key;
                this.sorting.order = data.order;
                this.getDataByFilter()
            },
            getDataByFilter() {
                setTimeout(() => {
                        this.$refs.validator.validate().then((result) => {
                            if (result) {
                                this.showLoader();
                                const {
                                    key,
                                    order
                                } = this.sorting;
                                const {
                                    perPage,
                                    page
                                } = this.pagination;
                                const filters = {};
                                if (this.filtering.attendanceDate) {
                                    filters.attendanceDate = this.filtering.attendanceDate;
                                }
                                const data = {
                                    filterjson: {
                                        filter: [filters],
                                        sort: [{
                                            key,
                                            order
                                        }],
                                        paging: [{
                                            startIndex: page,
                                            pageSize: perPage
                                        }]
                                    }
                                };
                                getSubordinatesAttendance(data)
                                    .then(this.handleResponse)
                                    .catch(this.handleError)
                            }
                        })
                    },
                    50
                )
            },
            pageChange(page) {
                this.pagination.page = page;
                this.getDataByFilter()
            },
            handleResponse(response) {
                this.hideLoader();
                this.subordinatesAttendance = response.data;
                this.pagination.total = response.NumberOfRecords;
                this.buttonToShow = this.filtering.statusSelected;
            },
        }
    }
    </script>
    
    <style lang="scss">
    .popupRow {
        padding: 5px 0 15px;
    }
    
    .pagination {
        margin: 10px 0 0;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        line-height: 26px;
    }
    
    .paginationText {
        margin: 0 20px;
    }
    
    .paginationButton {
        cursor: pointer;
        width: 26px;
        text-align: center;
        transition: background-color .2s ease-in-out, color .2s ease-in-out, box-shadow 200ms ease
    }
    
    .paginationButton:hover {
        background: #57a3f3;
        color: #fff;
    
        &:hover {
            box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);
        }
    }
    
    .filter {
        margin: -10px 0 10px;
    }
    
    .filterItem {
        display: inline-block;
        margin: 0 15px 15px 0;
    }
    
    .filterItemCheckbox {
        flex-basis: auto;
        align-self: flex-start;
        margin-top: 13px;
    }
    </style>
    